import {OnInit, OnDestroy, Component} from '@angular/core';

import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {CoreConfigService} from '@core/services/config.service';
import {CoreTranslationService} from '../../../../@core/services/translation.service';
import {TranslatePipe} from '@ngx-translate/core';
import {Router, RoutesRecognized} from '@angular/router';
import {ConsentService} from '../../../../app/core/service/consent.service';
import {environment} from "../../../../environments/environment";
import {injectGoogleTagManager} from "../../../core/utils/google-tag-manager";

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [
    TranslatePipe
  ],
})
export class FooterComponent implements OnInit, OnDestroy {
  public coreConfig: any;
  public year: number = new Date().getFullYear();

  // Private
  private _unsubscribeAll: Subject<any>;
  public subdomain = 'default';

  public tosUrl = '';
  public gdprUrl = '';
  public privacyPolicyUrl = '';
  public cookiesPolicyUrl = '';
  public speakUpPolicyUrl = '';

  constructor(public _coreConfigService: CoreConfigService,
    private _coreTranslationService: CoreTranslationService,
    private _router: Router,
    private consentService: ConsentService) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this._router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        this.subdomain = val.state.root.firstChild.params['subdomain'];
      }
    });
  }

  ngOnInit(): void {
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });

    this.consentService.getConsentLinks().pipe(takeUntil(this._unsubscribeAll)).subscribe(links => {
      this.gdprUrl = links.gdprUrl;
      this.tosUrl = links.termsUrl;
      this.privacyPolicyUrl = links.privacyPolicyUrl;
      this.cookiesPolicyUrl = environment.cookiesPolicyUrl;
      this.speakUpPolicyUrl = environment.speakUpPolicyUrl;
    });
  }

  openCookieSettings(): void {
    const win = window as Window & {
      OneTrust?: { ToggleInfoDisplay?: () => void };
      Optanon?: { ToggleInfoDisplay?: () => void };
    };

    if (typeof win.OneTrust?.ToggleInfoDisplay === 'function') {
      win.OneTrust.ToggleInfoDisplay();
      return;
    }

    if (typeof win.Optanon?.ToggleInfoDisplay === 'function') {
      win.Optanon.ToggleInfoDisplay();
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }

  openNewTab(url: string) {
    window.open(url);
  }

}
